export const urlRegMatch = /^https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)*(?::\d+)?((?:\/\w+)|(?:-\w+))*\/?(?![^<]*(?:<\/\w+>|\/?>))/;

export const combinePaginationUrl = (sourceUrl, perPage, page = null, sort = null) => {
    const url = new URL(sourceUrl);
    const params = new URLSearchParams(url.search.slice(1));
    if (perPage) {
        params.append('per_page', perPage);
    }
    if (page) {
        params.append('page', page);
    }
    if (sort) {
        params.append('sortBy', sort.by);
        params.append('sortOrder', sort.order);
    }

    const path = url.pathname;

    return url.origin + path + '?' + params.toString();
};

export const downloadSource = (path, url) => {
    axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', path);
        document.body.appendChild(link);
        link.click();
    });
};

export const downloadFileFromUrl = async (url, filename = '') => {
    axios.get(url).then((response) => {
        const { data } = response;

        const uri = data.url;
        const fileName = data.filename || filename;
        if (uri) {
            const link = document.createElement('a');
            link.href = uri;
            link.setAttribute('target', '_blank');
            if (fileName) {
                link.setAttribute('download', fileName);
            }
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    });
};

export function addQueryStringToUrl(url, key, value) {
    const urlObject = new URL(url);
    const searchParams = new URLSearchParams(urlObject.search);

    searchParams.set(key, value);

    urlObject.search = searchParams.toString();

    return urlObject.toString();
}
